module.exports = __webpack_public_path__ + "static/media/add parent regist.d2861a02.svg";